import React from 'react';
import { Stack } from '@mui/material';
import { FormCheckbox } from 'components/form';
import { ChecklistAttribute, ChecklistItem } from '../../api';

export const Checklist = ({
  onChange,
  checklist,
  isLoading,
}: {
  isLoading: boolean;
  checklist: ChecklistAttribute;
  onChange: (checklistItem: ChecklistItem, nextValue: boolean) => void;
}) => {
  return (
    <Stack gap="0.25rem">
      {checklist.value.map(checklistItem => (
        <FormCheckbox
          disabled={isLoading}
          key={checklistItem.name}
          label={checklistItem.name}
          checked={checklistItem.value}
          onChange={(_, checked) => onChange(checklistItem, checked)}
        />
      ))}
    </Stack>
  );
};
